import { Injectable } from 'angular-ts-decorators';

import type { LocalStorage } from '@shared/app/scripts/services/local-storage';

/**
 * Service that wrapps {@link LocalStorage}, and works with json instead of
 * strings.
 */
@Injectable('localJsonStorage')
export class LocalJsonStorage {
  constructor(private localStorage: LocalStorage) {
    'ngInject';
  }

  /**
   * @param key identifier
   * @param value to be saved
   * @param {any} arg
   */
  setItem<T = any>(key: string, value: T) {
    this.localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Read value from storage
   * @param key identifier
   * @return {T}
   * Value that was stored
   */
  getItem<T = any>(key: string): T {
    return <T>JSON.parse(this.localStorage.getItem(key));
  }

  /**
   * Removes stored value
   * @param key identifier
   */
  removeItem(key: string) {
    return this.localStorage.removeItem(key);
  }
}
